import React from 'react';
import { connect } from 'react-redux';
import { hashHistory, Link } from 'react-router';
import '../login.css';
import Header from '../Components/Header/HeaderUnauthorized';
import ValidationMessage from '../Components/ValidationMessage';
import AccessCode from '../Components/AccessCode';
import { registerUser, identifyUser, saveRegState } from '../actions/registrationActions';
import { showGlobalMessage } from '../actions/environmentActions';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import Divider from 'material-ui/Divider';
import Dialog from 'material-ui/Dialog';
import { tokenExists } from '../utils/tokenUtil';
import { resourceApi } from '../utils/fetchUtil';

class NewUserPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            emailConfirm: "",
            password: "",
            passwordConfirm: "",
            agreed: false,
            passwordsMatch: false,
            emailsMatch: false
        };
    }


    componentDidMount(){

        if(tokenExists()) {

            var self = this;

            let config = {
                method: 'get',
                url: `auth/checkToken`
            };
            
            resourceApi(config) 
            .then(function (response) {
        
                const { isIdentified } = this.props.register;

                if(!isIdentified) {
                    hashHistory.push("/go/identity");
                }
            })
            .catch(function (error) {
                self.props.showGlobalMessage("You've already created an account.  Please login to verify your identity and complete your registration.  If you can't login, please click 'unable to login' and reset your password. ");
                hashHistory.push("/");
            });

           
        }
        else {
            const { email, emailConfirm, password, passwordConfirm, agreedToTerms } = this.props.register;

            this.setState({ 
                email: email, 
                emailConfirm: emailConfirm,
                password: password,
                passwordConfirm: passwordConfirm,
                agreed: agreedToTerms,
                emailsMatch: (email === emailConfirm),
                passwordsMatch: (password === passwordConfirm)
            });
        }
    }

    createUserAccount = () => {
        this.props.onRegisterClick(this.getCreds());
    }

    getCreds = () => {
        const creds = { 
            email: this.state.email.trim(),
            emailConfirm: this.state.emailConfirm.trim(),
            password: this.state.password.trim(), 
            passwordConfirm: this.state.passwordConfirm.trim(), 
            accessCode: "0000",
            agreedToTerms: this.state.agreed 
        };

        return creds;
    }

    emailChange = (event, value) => {
        
        var ce = this.state.emailConfirm; 

        this.setState({ 
            email: value, 
            emailsMatch: (ce === value) 
        });
    }

    emailConfirmChange = (event, value) => {
        
        var u = this.state.email;

        this.setState({ 
            emailConfirm: value, 
            emailsMatch: (u === value) 
        });
    }

    passwordChange = (event, value) => {

        var cp = this.state.passwordConfirm; 

        this.setState({ 
            password: value, 
            passwordsMatch: (cp === value) 
        });
    }

    confirmPasswordChange = (event, value) => {
        
        var password = this.state.password;
        
        this.setState({ 
            passwordConfirm: value, 
            passwordsMatch: (password === value) 
        });
    }

    termsCheckChanged = (event, isInputChecked) => {
        this.setState({ agreed: isInputChecked });
    }
    
    terms = () => {
        this.props.saveState(this.getCreds());
        hashHistory.push('/go/terms');
    }

    privacy = () => {
        this.props.saveState(this.getCreds());
        hashHistory.push('/go/privacy');
    }

    render() {
    
        const styleWhite = {
            color:"#fff"
        };

        return (
            <div>
                <Header>
                    <span className="white" >Create Account</span>
                </Header>
                <div className="container" >
                    <form className="container" >
                        <p className="white truenoLight">Please provide your email address and a password to login with.</p>
                        <br />
                        <TextField 
                            hintText="Email address" 
                            value={this.state.email} 
                            onChange={this.emailChange} 
                            fullWidth={true} 
                            inputStyle={styleWhite} 
                            hintStyle={styleWhite} 
                            autoCapitalize="none" 
                            type="email" 
                        />
                        <br />
                        <br />
                        <TextField 
                            hintText="Confirm email address" 
                            value={this.state.emailConfirm} 
                            onChange={this.emailConfirmChange} 
                            fullWidth={true} 
                            inputStyle={styleWhite} 
                            hintStyle={styleWhite} 
                            autoCapitalize="none" 
                            type="email" 
                        />
                        {(!this.state.emailsMatch) && (this.state.email.length > 0) && (this.state.emailConfirm.length > 0) && (
                            <ValidationMessage message="The emails do not match." />
                        )}
                        <br />
                        <br />
                        <p className="white truenoLight" >Passwords must contain at least 8 characters.</p>
                        <br />
                        <TextField 
                            hintText="Password" 
                            value={this.state.password} 
                            onChange={this.passwordChange} 
                            type="password" 
                            fullWidth={true} 
                            inputStyle={styleWhite} 
                            hintStyle={styleWhite} 
                        />
                        {(this.state.password.length > 0) && (this.state.password.length < 8) && (
                            <ValidationMessage message="Not enough characters. " />
                        )}
                        <br />
                        <br />
                        <TextField 
                            hintText="Confirm password" 
                            value={this.state.passwordConfirm} 
                            onChange={this.confirmPasswordChange} 
                            type="password" 
                            fullWidth={true} 
                            inputStyle={styleWhite} 
                            hintStyle={styleWhite} 
                        />
                        {(!this.state.passwordsMatch) && (this.state.password.length > 0) && (this.state.passwordConfirm.length > 0) && (
                            <ValidationMessage message="The passwords do not match." />
                        )}
                        
                        <br />
                        <br />
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <Checkbox iconStyle={{fill:'#fff'}} onCheck={this.termsCheckChanged} checked={this.state.agreed} />
                                    </td>
                                    <td className="white truenoLight">
                                        <p>I agree to the <Link onClick={this.terms} className="white underline" >Terms of Use</Link> and <Link onClick={this.privacy} className="white underline" >Privacy Policy</Link>
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <br />
                        {(this.state.passwordsMatch) && 
                         (this.state.password.length >= 8) && 
                         (this.state.emailsMatch) && 
                         (this.state.email.length > 3) && 
                         (this.state.agreed) && 
                         (
                            <RaisedButton 
                                label="Next Step" 
                                primary={true} 
                                onClick={this.createUserAccount} 
                                fullWidth={true} 
                                style={{height:45}} 
                                labelStyle={{fontSize: '26px'}} 
                            />
                         )
                        }
                    </form>
                </div>
            </div>
        );
    }

};


const mapDispatchToProps = (dispatch) => {
  return {
    onRegisterClick: (creds) => {
      dispatch(registerUser(creds))
    },
    saveState: (creds) => {
      dispatch(saveRegState(creds))
    },
    showGlobalMessage:(message) => {
        dispatch(showGlobalMessage(message));
    }
  }
}


function mapStateToProps(state) {
    
    const register = state.thisApp.register;

    return {
        register
    }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewUserPage)





// WEBPACK FOOTER //
// ./src/Pages/NewUser.js